import { useEffect, useState } from 'react';

import useApi from 'Lib/hooks/useApi';
import useNotify from 'Lib/hooks/useNotify';
import SelectField from 'Lib/muiComponents/form/SelectField';

function LetterTemplateField(props) {
    const fetchOptions = useApi(props.api);
    const { toastError } = useNotify();

    const [options, setOptions] = useState([]);

    useEffect(() => {
        fetchOptions({ templateObjectTypeID: props.templateObjectTypeID, pageSize: 10000, isActive: 1 })
            .then(response => {
                setOptions(
                    response.data.map(row => ({
                        obj: row,
                        label: row.letterTemplate.name,
                        value: row.letterTemplate.letterTemplateID
                    }))
                );
            })
            .catch(error => {
                toastError(error);
            });
    }, []);

    return <SelectField id={props.id} name={props.name} label={props.label} options={options} onChange={props.onChange} />;
}

export default LetterTemplateField;
